import "./styles.css";
import React, { useState } from "react";
import { Row, Col, Card, Steps, Space, Typography, message, Layout, App } from "antd";
import { CadastroUsuario } from "./components/cadastroUsuario";
import { IMAGES } from "../../constants/images";
import { getAge } from "../../helpers/getAge";
import { CadastroResponsavel } from "./components/cadastroResponsavel";
import { Curriculo } from "./components/curriculo";
import { Vagas } from "./components/vagas";
import { addCurriculoUsuario } from "../../api/autenticacao";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
const { Text, Link, Title } = Typography;

const Cadastro = () => {
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({});
  const { modal } = App.useApp();
  const navigate = useNavigate();

  const onFinishCadastro = (values) => {
    setFormData((e) => ({ ...e, ...values }));
    const age = getAge(values?.data_nascimento ?? "");

    if (age < 18) {
      setCurrentStep(1);
    } else {
      setCurrentStep(2);
    }
  };

  const onFinishCadastroResponsavel = (values) => {
    setFormData((e) => ({ ...e, ...values }));
    setCurrentStep(2);
  };

  const onPreviousCurriculo = () => {
    const age = getAge(formData?.data_nascimento ?? "");

    if (age < 18) {
      setCurrentStep(1);
    } else {
      setCurrentStep(0);
    }
  };

  const onFinishCurriculo = (values) => {
    setFormData((e) => ({ ...e, ...values }));
    setCurrentStep(3);
  };

  const onFinishVagas = (values) => {
    
    const formularioFinal = {
      ...formData,
      ...values,
    };

    setFormData(formularioFinal);
    onSubmit(formularioFinal);
  };

  const items = [
    {
      key: "Cadastro",
      title: "Cadastro",
    },
    {
      key: "Responsável",
      title: "Responsável",
    },
    {
      key: "Currículo",
      title: "Currículo",
    },
    {
      key: "Vagas",
      title: "Vagas",
    },
  ];

  const cadastrarCurriculoUsuario = async (formulario) => {
    setLoading(true);
    try {
      const retorno = await addCurriculoUsuario(formulario);
      if (retorno?.statusCode === 200) {
        modal.success({
          title: "O seu currículo foi enviado com sucesso!",
          content:
            "Você receberá uma senha para acesso via SMS e e-mail. Esta senha poderá ser utilizada para futuros acessos e atualização do seu cadastro",
        });
        navigate("/login");
      } else if (retorno?.statusCode === 403) {
        modal.warning({
          title: "Currículo encontrado!",
          content:
            "O CPF informado ja está cadastrado em nosso sistema, para editar informe o número de celular correto ou faça o login no sistema.",
        });
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const onSubmit = (formulario) => {
    const form = new FormData();
    form.append("cpf", formulario?.cpf?.replace(/[^\d]+/g, ""));
    form.append("nome", formulario?.nome);
    form.append("celular", formulario?.celular?.replace(/[^\d]+/g, ""));
    form.append("email", formulario?.email ?? "");
    form.append("data_nascimento", dayjs(formulario?.data_nascimento).format("YYYY-MM-DD"));
    form.append("id_cad_municipios", formulario?.id_cad_municipios);
    form.append("id_cad_sexos", formulario?.id_cad_sexos);
    form.append("pcd", formulario?.pcd);
    form.append("id_cad_tipos_vinculos", formulario?.id_cad_tipos_vinculos);
    form.append("nome_responsavel", formulario?.nome_responsavel);
    form.append("experiencias", formulario?.experiencias);
    form.append("cpf_responsavel", formulario?.cpf_responsavel?.replace(/[^\d]+/g, ""));
    form.append("file", formulario?.file?.[0]?.originFileObj ?? "");
    form.append("imagem", formulario?.imagem?.[0]?.originFileObj ?? "");

    for (let i = 0; i < formulario?.vagas?.length; i++) {
      form.append("vagas[]", formulario?.vagas?.[i]);
    }

    for (let i = 0; i < formulario?.formacoes?.length; i++) {
      form.append(
        `formacoes[${i}][id_cad_classificacao_escolaridade]`,
        formulario?.formacoes?.[i]?.id_cad_classificacao_escolaridade
      );
      form.append(`formacoes[${i}][descricao]`, formulario?.formacoes?.[i]?.descricao ?? "");
    }

    cadastrarCurriculoUsuario(form);
  };

  return (
    <Row justify="center" align="middle" className="full-width">
      <Col xs={23} sm={20} md={18} lg={16} xl={14} xxl={8}>
        <Card title={<img src={IMAGES?.curriculos} height={80} width="100%" className="resize-contain" />}>
          <Space direction="vertical" className="full-width" size={20}>
            <div>
              <Title className="title" align="center">
                Cadastro
              </Title>

              <Layout.Content className="text-center">
                <Text className="font-middle">
                  Já possui um cadastro?{" "}
                  <Link className="font-middle" onClick={() => navigate("/login")}>
                    Faça o Login
                  </Link>
                </Text>
              </Layout.Content>
            </div>

            <Steps size="large" current={currentStep} items={items} />

            <div>
              <div className={currentStep === 0 ? "" : "hidden"}>
                <CadastroUsuario loadingComponent={loading} onFinish={onFinishCadastro} />
              </div>
              <div className={currentStep === 1 ? "" : "hidden"}>
                <CadastroResponsavel
                  loadingComponent={loading}
                  onFinish={onFinishCadastroResponsavel}
                  onPrevious={() => setCurrentStep(0)}
                />
              </div>
              <div className={currentStep === 2 ? "" : "hidden"}>
                <Curriculo loadingComponent={loading} onFinish={onFinishCurriculo} onPrevious={onPreviousCurriculo} />
              </div>
              <div className={currentStep === 3 ? "" : "hidden"}>
                <Vagas loadingComponent={loading} onFinish={onFinishVagas} onPrevious={() => setCurrentStep(2)} />
              </div>
            </div>
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default Cadastro;
